const POLICY_VERSION = '22';
// update policy version to not lose cookies (complianz.min.js deletes the cookies
// if config policy version is not equal to cookie policy version)
const getPolicyVersion = () => {
  const match = document.cookie.match(/cmplz_policy_id=(\d+)(?:[^\d]|$)/);

  if (match) {
    return match[1];
  }
  return POLICY_VERSION;
};

/**
 * initializing window.complianz avoids requests that will be called in complianz.min.js
 */
const initComplianz = (region: string) => {
  if (typeof window !== 'undefined' && region) {
    (window as any).complianz = {
      region,
      locale: 'lang=en&locale=en_US',
      prefix: 'cmplz_',
      geoip: 1,
      user_banner_id: '1',
      block_ajax_content: '1',
      banner_version: '25',
      version: '6.5.4',
      store_consent: true,
      do_not_track_enabled: false,
      consenttype: region === 'eu' ? 'optin' : 'other',
      dismiss_timeout: false,
      disable_cookiebanner: false,
      soft_cookiewall: false,
      dismiss_on_scroll: false,
      cookie_expiry: 365,
      url: 'https://klang.io/wp-json/complianz/v1/',
      set_cookies_on_root: '1',
      cookie_domain: '.klang.io',
      current_policy_id: getPolicyVersion(),
      cookie_path: '/',
      categories: { statistics: 'statistics', marketing: 'marketing' },
      tcf_active: false,
      css_file:
        'https://klang.io/wp-content/uploads/complianz/css/banner-{banner_id}-{type}.css?v=25',
      placeholdertext: 'Click to accept {category} cookies and enable this content',
      page_links: {
        eu: {
          'cookie-statement': {
            title: 'Cookie Policy',
            url: 'https://klang.io/cookie-policy-eu/',
          },
          'privacy-statement': { title: 'Privacy Policy', url: 'https://klang.io/privacy/' },
          impressum: { title: 'Imprint', url: 'https://klang.io/imprint/' },
        },
        us: { impressum: { title: 'Imprint', url: 'https://klang.io/imprint/' } },
      },
      tm_categories: true,
      forceEnableStats: false,
      preview: false,
      clean_cookies: false,
    };
    sessionStorage.setItem('cmplz_user_data', JSON.stringify((window as any).complianz));

    const script = document.createElement('script');
    if (!document.getElementById('cmplz-cookiebanner-js')) {
      script.id = 'cmplz-cookiebanner-js';
      script.src = 'https://klang.io/wp-content/plugins/complianz-gdpr-premium/cookiebanner/js/complianz.min.js';
      script.async = true;
      document.body.appendChild(script);

      setTimeout(() => {
        // overwrites tracking function: complianz request '/track' causes CORS error
        (window as any).cmplz_track_status = () => {};
      }, 1000);
    }
  }
};

export default initComplianz;
